"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Text"));

require("../assets/css/font-face.css");

require("./Timeline.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var renderTimeline = function renderTimeline(data) {
  return data.map(function (item, index) {
    var bgColor = index === 0 ? item.color : '';
    return _react.default.createElement("li", {
      className: "timeline__item",
      key: index
    }, _react.default.createElement("span", {
      className: "timeline__dot",
      style: {
        backgroundColor: item.color
      }
    }), _react.default.createElement("div", {
      className: "timeline__date",
      style: {
        backgroundColor: bgColor
      }
    }, _react.default.createElement("span", {
      className: "timeline__arrow",
      style: {
        backgroundColor: bgColor
      }
    }), _react.default.createElement("span", {
      className: "timeline__date-text"
    }, item.date)), _react.default.createElement("div", null, _react.default.createElement("h3", {
      className: "timeline__title"
    }, item.title), _react.default.createElement("p", {
      className: "timeline__text"
    }, item.desc)));
  });
};

var Timeline = function Timeline(_ref) {
  var data = _ref.data,
      className = _ref.className;
  var wrapperClass = 'timeline';
  if (className) wrapperClass += " ".concat(className);

  if (data.length === 0) {
    return _react.default.createElement(_Text.default, {
      className: wrapperClass
    }, "Nenhum dado encontrado.");
  }

  return _react.default.createElement("ul", {
    className: wrapperClass
  }, renderTimeline(data));
};

Timeline.defaultProps = {
  data: []
};
Timeline.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    date: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    desc: _propTypes.default.string.isRequired,
    color: _propTypes.default.string.isRequired
  }))
};
var _default = Timeline;
exports.default = _default;